<template>
  <component :is="currentComponent" :key="deviceClass" :detail="detail" />
</template>

<script>
import pcContent from '@/components/ModelOne/pcContent.vue'
import h5Content from '@/components/ModelOne/h5Content.vue'
export default {
  components: { pcContent, h5Content },
  name: 'pageModel1',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    currentComponent() {
      return this.deviceClass == 'pc' ? 'pcContent' : 'h5Content'
    },
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  created() {},
  methods: {},
}
</script>
